import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  Signal,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BadgeModule } from 'primeng/badge';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { OnlineStatusService } from '../services/online-status/online-status.service';
import { AdminProfileStore } from '../store/admin-profile/admin-profile.store';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styles: [
    `
      .cloud {
        font-size: 2rem;
        margin-right: 0.5rem;
      }
    `,
  ],
  imports: [BadgeModule, BlockUIModule, ButtonModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTopBarComponent {
  layoutService = inject(LayoutService);
  onlineService = inject(OnlineStatusService);
  private auth = inject(AuthService);
  private router = inject(Router);
  private document = inject(DOCUMENT);

  private adminProfileStore = inject(AdminProfileStore);

  isOnline: Signal<boolean> = this.onlineService.online;
  adminName: Signal<string | null> = this.adminProfileStore.name;
  blockui = signal(false);

  items: MenuItem[];

  menuButton = viewChild<ElementRef>('menubutton');

  topbarMenuButton = viewChild<ElementRef>('topbarmenubutton');

  menu = viewChild<ElementRef>('topbarmenu');

  isDev = environment.env !== 'production';

  constructor() {
    inject(DestroyRef).onDestroy(() => {
      // PrimeNG BlockUI appends its overlay to document.body but does not
      // remove it when the component is destroyed while blocked. Clean up
      // any orphaned overlay so the next page is not stuck behind it.
      this.document
        .querySelectorAll('.p-blockui-mask-document')
        .forEach((el) => el.remove());
    });
  }

  async processLogout() {
    this.blockui.set(true);
    try {
      const success = await firstValueFrom(
        this.auth.logoutAndResetCsrf(),
      );
      if (success) {
        this.router.navigate(['/auth/login']);
      }
    } finally {
      this.blockui.set(false);
    }
  }
}
